<template>
  <div class="flex justify-center items-center">
    <img src="~/assets/img/rolling-ring.svg" :alt="$t('go_local.loading')" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "GoLocalSpinner"
})
</script>

<style lang="css"></style>
